import { getImagePath } from "@/lib/utils";
import { get } from "http";

  const testimonials = [
    {
      id: 1,
      name: "Priya Sharma",
      location: "Pune, Maharashtra",
      rating: 5,
      content:
        "KST ने आमच्या कुटुंबाला एकत्र आणले आहे. आता आम्ही सगळे मिळून मराठी चित्रपट पाहतो आणि आमचे बंध अधिक मजबूत झाले आहेत.",
      role: "Family User",
      image: {
        src: getImagePath("/images/testimonials/testi-1.png"),
        width: 320,
        height: 320,
      },
    },
    {
      id: 2,
      name: "Rajesh Patil",
      location: "Satara, Maharashtra",
      rating: 5,
      content:
        "As a partner, KST has opened new business opportunities in our village. The response from families has been overwhelming!",
      role: "Distribution Partner",
      image: {
        src: getImagePath("/images/testimonials/testi-2.png"),
        width: 320,
        height: 320,
      },
    },
    {
      id: 3,
      name: "Sneha Kulkarni",
      location: "Nashik, Maharashtra",
      rating: 5,
      content:
        "गुणवत्तापूर्ण मराठी चित्रपट घरबसल्या पाहण्याची सुविधा मिळाली. इंटरनेटची गरज नाही आणि आवाज-चित्र उत्कृष्ट आहे!",
      role: "Satisfied Customer",
      image: {
        src: getImagePath("/images/testimonials/testi-3.png"),
        width: 320,
        height: 320,
      },
    },
    {
      id: 4,
      name: "Bapurao Shinde Satara",
      location: "Kolhapur, Maharashtra",
      rating: 5,
      content:
        "KST platform helped us reach rural audiences effectively. Our regional film got the exposure it deserved.",
      role: "Film Producer",
      image: {
        src: getImagePath("/images/testimonials/testi-4.png"),
        width: 320,
        height: 320,
      },
    },
  ];
export default testimonials;